export class SalutationTypeData {
    private salutationTypeList: string[] = ['Mr', 'Mrs', 'Ms'];
    public getSalutationTypeList(): Array<string> {
        return this.salutationTypeList;
    }
}
